const AUTH_TOKEN_KEY = 'auth-token';

export function getAuthToken() {
  if (typeof localStorage === 'undefined') {
    return null;
  }
  const token = localStorage.getItem(AUTH_TOKEN_KEY);
  if (!token || token === 'undefined') {
    return null;
  }
  return token;
}

export function setAuthToken(token) {
  if (typeof localStorage === 'undefined' || !token) {
    return;
  }
  localStorage.setItem(AUTH_TOKEN_KEY, token);
}

export function clearAuthToken() {
  if (typeof localStorage === 'undefined') {
    return;
  }
  localStorage.removeItem(AUTH_TOKEN_KEY);
}

export function hasAuthToken() {
  return Boolean(getAuthToken());
}
